import { render, staticRenderFns } from "./HostingSsh.vue?vue&type=template&id=7f0806ae&"
import script from "./HostingSsh.vue?vue&type=script&lang=js&"
export * from "./HostingSsh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports